module.exports = __webpack_public_path__ + "fonts/DM_Serif_Display-400-latin-ext20.fbcccd0.woff2";